<template>
	<div> 		
		<button
			@click="logear()"
			class="btn text-white btn-login"
			type="button">
			<i class="fa fa-user-alt"></i>
			<span class="ml-1 d-none d-sm-inline">Iniciar Sesion</span>
		</button>
		
		<input @click="menu=true; soloLogin=false" id="myMenu" ref="checkMenu" type="checkbox" />
		<label for="myMenu">
			<span class="bar top"></span>
			<span class="bar middle"></span>
			<span class="bar bottom"></span>
		</label>
		
		<div class="overlay-menu text-center">
			<div class="row justify-content-center align-items-center h-50" v-if="menu==true && soloLogin==false">
				<div class="col-8 col-sm-7 col-lg-6 col-xl-5">
					<div class="d-flex flex-column align-self-center align-items-center">
						<div class="col-12 pb-3">
							<router-link @click.native="cerrarMenu" class="link fuenteMenu py-2" to="/">Inicio</router-link>
							<router-link @click.native="cerrarMenu" class="link fuenteMenu py-2" to="/nosotros">Nosotros</router-link>
							<router-link
								@click.native="cerrarMenu"
								class="link fuenteMenu py-2"
								to="/quiero-ser-cliente"
							>Quiero ser cliente</router-link>
							<router-link
								@click.native="cerrarMenu"
								class="link fuenteMenu py-2"
								to="/preguntas-frecuentes"
							>Preguntas frecuentes</router-link>
							<router-link @click.native="cerrarMenu" class="link fuenteMenu py-2" to="/contacto">Contacto</router-link>
							<div class="border"></div>
							<router-link @click.native="cerrarMenu" class="link fuenteMenu py-2" to="/portal-proveedores">Portal para proveedores</router-link>
							<!--
							<router-link class="link fuenteMenu py-2" to="/blog-de-noticias" v-show="$router.currentRoute.path != '/blog-de-noticias'">Blog de noticias</router-link>
							-->
							<router-link class="link fuenteMenu py-2" to="/bolsa-trabajo">Bolsa de trabajo</router-link>
							
						</div>
						<!-- <div class="col-12">
							<p class="fuenteEtiqueta pt-3">¿Eres cliente difarmer? Inicia sesi&oacute;n</p>
						</div>
						<div class="col-12 col-sm-10">
							<button
								@click="menu=false"
								class="btn btn-block btn-blue-1 text-white"
								type="button"
							>Iniciar sesi&oacute;n</button>
						</div> -->
					</div>
				</div>
			</div>
			<Login v-if="soloLogin"
					@envioCorreo="cerrarMenu()">
			</Login>
		</div>
	</div>
</template>

<script>
	import Login from "@/views/publica/Login"
	export default {
		components: {
			Login,
		},
		data() {
			return {
				menu: true,
				soloLogin: false
			}
		},
		methods: {
			cerrarMenu() {
				if (this.$refs.checkMenu) {
					this.soloLogin=false
					this.$refs.checkMenu.checked = false
				}
			},
			logear(){
				this.menu=true
				this.soloLogin=true

				if (this.$refs.checkMenu) {
					this.$refs.checkMenu.checked = true
				}
			}
		},
	}
</script>

<style scoped>
	.overlay-menu {
		left: 0px;
		top: 0px;
		position: fixed;
		background-color: rgba(3, 15, 44, 0);
		width: 100%;
		height: 0px;
		transition: all 0.5s ease-in-out;
		z-index: 100;
		overflow: hidden;
		/* display: none; */
	}

	input[type="checkbox"] {
		display: none;
		transition: all 1s;
		height: 0px;
	}

	input[type="checkbox"]:checked ~ .overlay-menu {
		background-color: rgba(3, 15, 44, 0.95);
		height: 150vh!important;
		display: block;
	}

	input[type="checkbox"]:checked ~ label .top {
		-webkit-transform: translateY(10px) rotateZ(45deg);
		-moz-transform: translateY(10px) rotateZ(45deg);
		-ms-transform: translateY(10px) rotateZ(45deg);
		-o-transform: translateY(10px) rotateZ(45deg);
		transform: translateY(10px) rotateZ(45deg);
	}

	input[type="checkbox"]:checked ~ label .bottom {
		-webkit-transform: translateY(-10px) rotateZ(-45deg);
		-moz-transform: translateY(-10px) rotateZ(-45deg);
		-ms-transform: translateY(-10px) rotateZ(-45deg);
		-o-transform: translateY(-10px) rotateZ(-45deg);
		transform: translateY(-10px) rotateZ(-45deg);
	}

	input[type="checkbox"]:checked ~ label .middle {
		width: 0;
	}

	.middle {
		margin: 0 auto;
	}

	label {
		top: 2em;
		right: 2.5em;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: var(--color-azul);
		position: fixed;
		cursor: pointer !important;
		z-index: 101;
		padding-top: 2px;
	}

	.bar {
		display: block;
		background-color: var(--color-blanco);
		width: 25px;
		height: 4px;
		border-radius: 0px;
		margin: 6px auto;
		transition: background-color 0.2s ease-in, transform 0.2s ease-in,
			width 0.2s ease-in;
	}

	.fuenteMenu {
		font-weight: 300;
	}
	.fuenteEtiqueta {
		font-size: 14px !important;
	}
	.fuenteBoton {
		font-family: "Open Sans", sans-serif;
		background-color: var(--color-azul) !important;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 767px) {
		label {
			top: 1em;
			right: 1.5em;
			position: fixed;
			cursor: pointer !important;
			z-index: 101;
		}
		.fuenteMenu {
			font-size: 18px !important;
		}
		.fuenteEtiqueta {
			font-size: 14px !important;
		}
		.fuenteBoton {
			font-size: 16px !important;
		}
		.btn-login{
			right: 5.5em;	
			background:var(--color-azul);	
			position: fixed;	
			margin-top: 1em;
		}
	}
	/* md 768 */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		label {
			top: 1em;
			right: 1.5em;
			position: fixed;
			cursor: pointer !important;
			z-index: 101;
		}
		.fuenteMenu {
			font-size: 24px !important;
			font-weight: 300;
		}
		.fuenteEtiqueta {
			font-family: "Open Sans", sans-serif;
			font-size: 14px !important;
		}
		.fuenteBoton {
			font-family: "Open Sans", sans-serif;
			font-size: 16px !important;
			background-color: var(--color-azul) !important;
		}
		.btn-login{
			right: 5.5em;	
			background:var(--color-azul);	
			position: fixed;	
			margin-top: 1em;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.fuenteMenu {
			font-size: 18px !important;
		}
		.fuenteEtiqueta {
			font-size: 14px !important;
		}
		.fuenteBoton {
			font-size: 16px !important;
		}
		.btn-login{
			right: 5.5em;	
			background:var(--color-azul);	
			position: fixed;	
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fuenteMenu {
			font-size: 24px !important;
		}
		.fuenteEtiqueta {
			font-size: 14px !important;
		}
		.fuenteBoton {
			font-size: 16px !important;
		}
		.btn-login{
			right: 5.5em;	
			background:var(--color-azul);	
			position: fixed;	
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.fuenteMenu {
			font-size: 28px !important;
		}
		.fuenteEtiqueta {
			font-size: 18px !important;
		}
		.fuenteBoton {
			font-size: 16px !important;
		}
		.btn-login{
			right: 5.5em;	
			background:var(--color-azul);	
			position: fixed;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.fuenteMenu {
			font-size: 32px !important;
		}
		.fuenteEtiqueta {
			font-size: 24px !important;
		}
		.fuenteBoton {
			font-size: 24px !important;
		}
		.btn-login{
			right: 5.5em;	
			background:var(--color-azul);	
			position: fixed;	
		}
	}
</style>